/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateHtmlPageConfigReqVo,
  CreatePopupConfigReqVo,
  CreateWebsitImageConfigReqVo,
  ResponseBoolean,
  ResponseHtmlPageConfigInfoRespVo,
  ResponseListGetWebsitImageConfigSortListRespVo,
  ResponseListHtmlPageConfigInfoRespVo,
  ResponseListHtmlPageConfigPageTypeRespVo,
  ResponseListPopupConfigInfoRespVo,
  ResponseListWebsitImageConfigInfoRespVo,
  ResponseListWebsitImageTypeReqVo,
  ResponseLong,
  ResponsePageDataHtmlPageConfigInfoRespVo,
  ResponsePageDataPopupConfigInfoRespVo,
  ResponsePageDataWebsitImageConfigInfoRespVo,
  ResponsePopupConfigInfoRespVo,
  ResponseWebsitImageConfigInfoRespVo,
  UpdateHtmlPageConfigEnableReqVo,
  UpdateHtmlPageConfigReqVo,
  UpdatePopupConfigReqVo,
  UpdateWebsitImageConfigReqVo,
  WebsitImageConfigSortReqVo,
} from '../models/index';
import {
    CreateHtmlPageConfigReqVoFromJSON,
    CreateHtmlPageConfigReqVoToJSON,
    CreatePopupConfigReqVoFromJSON,
    CreatePopupConfigReqVoToJSON,
    CreateWebsitImageConfigReqVoFromJSON,
    CreateWebsitImageConfigReqVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseHtmlPageConfigInfoRespVoFromJSON,
    ResponseHtmlPageConfigInfoRespVoToJSON,
    ResponseListGetWebsitImageConfigSortListRespVoFromJSON,
    ResponseListGetWebsitImageConfigSortListRespVoToJSON,
    ResponseListHtmlPageConfigInfoRespVoFromJSON,
    ResponseListHtmlPageConfigInfoRespVoToJSON,
    ResponseListHtmlPageConfigPageTypeRespVoFromJSON,
    ResponseListHtmlPageConfigPageTypeRespVoToJSON,
    ResponseListPopupConfigInfoRespVoFromJSON,
    ResponseListPopupConfigInfoRespVoToJSON,
    ResponseListWebsitImageConfigInfoRespVoFromJSON,
    ResponseListWebsitImageConfigInfoRespVoToJSON,
    ResponseListWebsitImageTypeReqVoFromJSON,
    ResponseListWebsitImageTypeReqVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataHtmlPageConfigInfoRespVoFromJSON,
    ResponsePageDataHtmlPageConfigInfoRespVoToJSON,
    ResponsePageDataPopupConfigInfoRespVoFromJSON,
    ResponsePageDataPopupConfigInfoRespVoToJSON,
    ResponsePageDataWebsitImageConfigInfoRespVoFromJSON,
    ResponsePageDataWebsitImageConfigInfoRespVoToJSON,
    ResponsePopupConfigInfoRespVoFromJSON,
    ResponsePopupConfigInfoRespVoToJSON,
    ResponseWebsitImageConfigInfoRespVoFromJSON,
    ResponseWebsitImageConfigInfoRespVoToJSON,
    UpdateHtmlPageConfigEnableReqVoFromJSON,
    UpdateHtmlPageConfigEnableReqVoToJSON,
    UpdateHtmlPageConfigReqVoFromJSON,
    UpdateHtmlPageConfigReqVoToJSON,
    UpdatePopupConfigReqVoFromJSON,
    UpdatePopupConfigReqVoToJSON,
    UpdateWebsitImageConfigReqVoFromJSON,
    UpdateWebsitImageConfigReqVoToJSON,
    WebsitImageConfigSortReqVoFromJSON,
    WebsitImageConfigSortReqVoToJSON,
} from '../models/index';

export interface WebConfigEnableIdPutRequest {
    id: number;
    updateHtmlPageConfigEnableReqVo?: UpdateHtmlPageConfigEnableReqVo;
}

export interface WebConfigGroupPostRequest {
    createHtmlPageConfigReqVo?: CreateHtmlPageConfigReqVo;
}

export interface WebConfigIdDeleteRequest {
    id: number;
}

export interface WebConfigIdGetRequest {
    id: number;
}

export interface WebConfigIdPutRequest {
    id: number;
    updateHtmlPageConfigReqVo?: UpdateHtmlPageConfigReqVo;
}

export interface WebConfigPageGetRequest {
    currentPage: number;
    pageSize: number;
    pageName?: string;
    pageType?: number;
    orderType?: number;
    enable?: number;
}

export interface WebConfigPageInfoIdGetRequest {
    id: number;
    orderType?: number;
}

export interface WebConfigPageListPageTypeGetRequest {
    pageType: number;
    orderType?: number;
}

export interface WebConfigPopupEnableIdEnablePutRequest {
    id: number;
    enable: number;
}

export interface WebConfigPopupIdDeleteRequest {
    id: number;
}

export interface WebConfigPopupIdGetRequest {
    id: number;
}

export interface WebConfigPopupIdPutRequest {
    id: number;
    updatePopupConfigReqVo?: UpdatePopupConfigReqVo;
}

export interface WebConfigPopupListGetRequest {
    title?: string;
    enable?: number;
    show?: number;
}

export interface WebConfigPopupPageGetRequest {
    currentPage: number;
    pageSize: number;
    title?: string;
    enable?: number;
    show?: number;
}

export interface WebConfigPopupPostRequest {
    createPopupConfigReqVo?: CreatePopupConfigReqVo;
}

export interface WebConfigPopupShowIdShowPutRequest {
    id: number;
    show: number;
}

export interface WebConfigWebsitImageConfigEnableIdEnablePutRequest {
    id: number;
    enable: number;
}

export interface WebConfigWebsitImageConfigIdDeleteRequest {
    id: number;
}

export interface WebConfigWebsitImageConfigIdGetRequest {
    id: number;
}

export interface WebConfigWebsitImageConfigIdPutRequest {
    id: number;
    updateWebsitImageConfigReqVo?: UpdateWebsitImageConfigReqVo;
}

export interface WebConfigWebsitImageConfigListImageTypeGetRequest {
    imageType: number;
}

export interface WebConfigWebsitImageConfigPageGetRequest {
    currentPage: number;
    pageSize: number;
    imageType?: number;
    enable?: number;
}

export interface WebConfigWebsitImageConfigPostRequest {
    createWebsitImageConfigReqVo?: CreateWebsitImageConfigReqVo;
}

export interface WebConfigWebsitImageConfigQueryListGetRequest {
    imageType?: number;
    enable?: number;
}

export interface WebConfigWebsitImageConfigSortImageTypeGetRequest {
    imageType: number;
}

export interface WebConfigWebsitImageConfigSortPutRequest {
    websitImageConfigSortReqVo?: WebsitImageConfigSortReqVo;
}

/**
 * 
 */
export class WebConfigAppServiceApi extends runtime.BaseAPI {

    /**
     * 指定编号,进行停用|启用操作 指定编号,进行停用|启用操作
     * 指定编号,进行停用|启用操作
     */
    async webConfigEnableIdPutRaw(requestParameters: WebConfigEnableIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigEnableIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/enable/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHtmlPageConfigEnableReqVoToJSON(requestParameters['updateHtmlPageConfigEnableReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,进行停用|启用操作 指定编号,进行停用|启用操作
     * 指定编号,进行停用|启用操作
     */
    async webConfigEnableIdPut(requestParameters: WebConfigEnableIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigEnableIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 页面内容配置信息创建 页面内容配置信息创建
     * 页面内容配置信息创建
     */
    async webConfigGroupPostRaw(requestParameters: WebConfigGroupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateHtmlPageConfigReqVoToJSON(requestParameters['createHtmlPageConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 页面内容配置信息创建 页面内容配置信息创建
     * 页面内容配置信息创建
     */
    async webConfigGroupPost(requestParameters: WebConfigGroupPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigGroupPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,删除页面内容配置信息 指定编号,删除页面内容配置信息
     * 指定编号,删除页面内容配置信息
     */
    async webConfigIdDeleteRaw(requestParameters: WebConfigIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,删除页面内容配置信息 指定编号,删除页面内容配置信息
     * 指定编号,删除页面内容配置信息
     */
    async webConfigIdDelete(requestParameters: WebConfigIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号查询页面内容配置信息 指定编号查询页面内容配置信息
     * 指定编号查询页面内容配置信息
     */
    async webConfigIdGetRaw(requestParameters: WebConfigIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseHtmlPageConfigInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseHtmlPageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号查询页面内容配置信息 指定编号查询页面内容配置信息
     * 指定编号查询页面内容配置信息
     */
    async webConfigIdGet(requestParameters: WebConfigIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseHtmlPageConfigInfoRespVo> {
        const response = await this.webConfigIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,修改页面内容配置信息 指定编号,修改页面内容配置信息
     * 指定编号,修改页面内容配置信息
     */
    async webConfigIdPutRaw(requestParameters: WebConfigIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHtmlPageConfigReqVoToJSON(requestParameters['updateHtmlPageConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,修改页面内容配置信息 指定编号,修改页面内容配置信息
     * 指定编号,修改页面内容配置信息
     */
    async webConfigIdPut(requestParameters: WebConfigIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取页面内容配置信息列表信息(分页) 获取页面内容配置信息列表(分页)
     * 获取页面内容配置信息列表(分页)
     */
    async webConfigPageGetRaw(requestParameters: WebConfigPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataHtmlPageConfigInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling webConfigPageGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling webConfigPageGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageName'] != null) {
            queryParameters['pageName'] = requestParameters['pageName'];
        }

        if (requestParameters['pageType'] != null) {
            queryParameters['pageType'] = requestParameters['pageType'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataHtmlPageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 获取页面内容配置信息列表信息(分页) 获取页面内容配置信息列表(分页)
     * 获取页面内容配置信息列表(分页)
     */
    async webConfigPageGet(requestParameters: WebConfigPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataHtmlPageConfigInfoRespVo> {
        const response = await this.webConfigPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端按编号获取页面内容；下单须知可按订单类型返回对应配置 客户端·页面内容详情
     * 客户端·页面内容详情
     */
    async webConfigPageInfoIdGetRaw(requestParameters: WebConfigPageInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseHtmlPageConfigInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigPageInfoIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/page-info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseHtmlPageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端按编号获取页面内容；下单须知可按订单类型返回对应配置 客户端·页面内容详情
     * 客户端·页面内容详情
     */
    async webConfigPageInfoIdGet(requestParameters: WebConfigPageInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseHtmlPageConfigInfoRespVo> {
        const response = await this.webConfigPageInfoIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端-页面内容信息获取-列表 指定页面类型,获取页面内容信息列表(不分页) 客户端-根据页面类型,获取页面内容信息列表(不分页)
     * 客户端-根据页面类型,获取页面内容信息列表(不分页)
     */
    async webConfigPageListPageTypeGetRaw(requestParameters: WebConfigPageListPageTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListHtmlPageConfigInfoRespVo>> {
        if (requestParameters['pageType'] == null) {
            throw new runtime.RequiredError(
                'pageType',
                'Required parameter "pageType" was null or undefined when calling webConfigPageListPageTypeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/page-list/{pageType}`.replace(`{${"pageType"}}`, encodeURIComponent(String(requestParameters['pageType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListHtmlPageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端-页面内容信息获取-列表 指定页面类型,获取页面内容信息列表(不分页) 客户端-根据页面类型,获取页面内容信息列表(不分页)
     * 客户端-根据页面类型,获取页面内容信息列表(不分页)
     */
    async webConfigPageListPageTypeGet(requestParameters: WebConfigPageListPageTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListHtmlPageConfigInfoRespVo> {
        const response = await this.webConfigPageListPageTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取页面内容配置,页面区域类型 options 获取页面内容配置,页面区域类型 options
     * 获取页面内容配置,页面区域类型 options
     */
    async webConfigPageTypeOptionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListHtmlPageConfigPageTypeRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/page-type/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListHtmlPageConfigPageTypeRespVoFromJSON(jsonValue));
    }

    /**
     * 获取页面内容配置,页面区域类型 options 获取页面内容配置,页面区域类型 options
     * 获取页面内容配置,页面区域类型 options
     */
    async webConfigPageTypeOptionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListHtmlPageConfigPageTypeRespVo> {
        const response = await this.webConfigPageTypeOptionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 弹窗指定编号,修改启用停用状态 弹窗指定编号,修改是否使用状态
     * 弹窗指定编号,修改是否使用状态
     */
    async webConfigPopupEnableIdEnablePutRaw(requestParameters: WebConfigPopupEnableIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigPopupEnableIdEnablePut().'
            );
        }

        if (requestParameters['enable'] == null) {
            throw new runtime.RequiredError(
                'enable',
                'Required parameter "enable" was null or undefined when calling webConfigPopupEnableIdEnablePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/enable/{id}/{enable}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"enable"}}`, encodeURIComponent(String(requestParameters['enable']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 弹窗指定编号,修改启用停用状态 弹窗指定编号,修改是否使用状态
     * 弹窗指定编号,修改是否使用状态
     */
    async webConfigPopupEnableIdEnablePut(requestParameters: WebConfigPopupEnableIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigPopupEnableIdEnablePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,删除弹窗信息 指定编号,删除弹窗信息
     * 指定编号,删除弹窗信息
     */
    async webConfigPopupIdDeleteRaw(requestParameters: WebConfigPopupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigPopupIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,删除弹窗信息 指定编号,删除弹窗信息
     * 指定编号,删除弹窗信息
     */
    async webConfigPopupIdDelete(requestParameters: WebConfigPopupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigPopupIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,获取弹窗配置信息 指定编号,获取弹窗配置信息
     * 指定编号,获取弹窗配置信息
     */
    async webConfigPopupIdGetRaw(requestParameters: WebConfigPopupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePopupConfigInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigPopupIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePopupConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号,获取弹窗配置信息 指定编号,获取弹窗配置信息
     * 指定编号,获取弹窗配置信息
     */
    async webConfigPopupIdGet(requestParameters: WebConfigPopupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePopupConfigInfoRespVo> {
        const response = await this.webConfigPopupIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,修改弹窗信息 制定编号,修改弹窗信息
     * 制定编号,修改弹窗信息
     */
    async webConfigPopupIdPutRaw(requestParameters: WebConfigPopupIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigPopupIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePopupConfigReqVoToJSON(requestParameters['updatePopupConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,修改弹窗信息 制定编号,修改弹窗信息
     * 制定编号,修改弹窗信息
     */
    async webConfigPopupIdPut(requestParameters: WebConfigPopupIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigPopupIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端-弹窗列表（不分页） 客户端·弹窗列表（不分页）
     * 客户端·弹窗列表（不分页）
     */
    async webConfigPopupListGetRaw(requestParameters: WebConfigPopupListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListPopupConfigInfoRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['show'] != null) {
            queryParameters['show'] = requestParameters['show'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListPopupConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端-弹窗列表（不分页） 客户端·弹窗列表（不分页）
     * 客户端·弹窗列表（不分页）
     */
    async webConfigPopupListGet(requestParameters: WebConfigPopupListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListPopupConfigInfoRespVo> {
        const response = await this.webConfigPopupListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 弹窗配置信息分页列表 弹窗配置信息分页列表
     * 弹窗配置信息分页列表
     */
    async webConfigPopupPageGetRaw(requestParameters: WebConfigPopupPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataPopupConfigInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling webConfigPopupPageGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling webConfigPopupPageGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['show'] != null) {
            queryParameters['show'] = requestParameters['show'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataPopupConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 弹窗配置信息分页列表 弹窗配置信息分页列表
     * 弹窗配置信息分页列表
     */
    async webConfigPopupPageGet(requestParameters: WebConfigPopupPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataPopupConfigInfoRespVo> {
        const response = await this.webConfigPopupPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 弹窗信息创建 弹窗信息创建
     * 弹窗信息创建
     */
    async webConfigPopupPostRaw(requestParameters: WebConfigPopupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePopupConfigReqVoToJSON(requestParameters['createPopupConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 弹窗信息创建 弹窗信息创建
     * 弹窗信息创建
     */
    async webConfigPopupPost(requestParameters: WebConfigPopupPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigPopupPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 弹窗指定编号,修改是否展示状态 弹窗指定编号,修改是否展示状态
     * 弹窗指定编号,修改是否展示状态
     */
    async webConfigPopupShowIdShowPutRaw(requestParameters: WebConfigPopupShowIdShowPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigPopupShowIdShowPut().'
            );
        }

        if (requestParameters['show'] == null) {
            throw new runtime.RequiredError(
                'show',
                'Required parameter "show" was null or undefined when calling webConfigPopupShowIdShowPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/popup/show/{id}/{show}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"show"}}`, encodeURIComponent(String(requestParameters['show']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 弹窗指定编号,修改是否展示状态 弹窗指定编号,修改是否展示状态
     * 弹窗指定编号,修改是否展示状态
     */
    async webConfigPopupShowIdShowPut(requestParameters: WebConfigPopupShowIdShowPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigPopupShowIdShowPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定图片信息编号,修改状态 指定图片信息编号,修改状态
     * 指定图片信息编号,修改状态
     */
    async webConfigWebsitImageConfigEnableIdEnablePutRaw(requestParameters: WebConfigWebsitImageConfigEnableIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigWebsitImageConfigEnableIdEnablePut().'
            );
        }

        if (requestParameters['enable'] == null) {
            throw new runtime.RequiredError(
                'enable',
                'Required parameter "enable" was null or undefined when calling webConfigWebsitImageConfigEnableIdEnablePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/enable/{id}/{enable}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"enable"}}`, encodeURIComponent(String(requestParameters['enable']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定图片信息编号,修改状态 指定图片信息编号,修改状态
     * 指定图片信息编号,修改状态
     */
    async webConfigWebsitImageConfigEnableIdEnablePut(requestParameters: WebConfigWebsitImageConfigEnableIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigWebsitImageConfigEnableIdEnablePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,删除轮播图数据 指定编号,删除轮播图数据
     * 指定编号,删除轮播图数据
     */
    async webConfigWebsitImageConfigIdDeleteRaw(requestParameters: WebConfigWebsitImageConfigIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigWebsitImageConfigIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,删除轮播图数据 指定编号,删除轮播图数据
     * 指定编号,删除轮播图数据
     */
    async webConfigWebsitImageConfigIdDelete(requestParameters: WebConfigWebsitImageConfigIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigWebsitImageConfigIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,查询轮播图数据详情 指定编号,查询轮播图数据详情
     * 指定编号,查询轮播图数据详情
     */
    async webConfigWebsitImageConfigIdGetRaw(requestParameters: WebConfigWebsitImageConfigIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseWebsitImageConfigInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigWebsitImageConfigIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseWebsitImageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号,查询轮播图数据详情 指定编号,查询轮播图数据详情
     * 指定编号,查询轮播图数据详情
     */
    async webConfigWebsitImageConfigIdGet(requestParameters: WebConfigWebsitImageConfigIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseWebsitImageConfigInfoRespVo> {
        const response = await this.webConfigWebsitImageConfigIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,修改轮播图数据 指定编号,修改轮播图数据
     * 指定编号,修改轮播图数据
     */
    async webConfigWebsitImageConfigIdPutRaw(requestParameters: WebConfigWebsitImageConfigIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling webConfigWebsitImageConfigIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWebsitImageConfigReqVoToJSON(requestParameters['updateWebsitImageConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,修改轮播图数据 指定编号,修改轮播图数据
     * 指定编号,修改轮播图数据
     */
    async webConfigWebsitImageConfigIdPut(requestParameters: WebConfigWebsitImageConfigIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigWebsitImageConfigIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端-指定图片类型,获取图片列表(不分页) 客户端-指定图片类型,获取图片列表(不分页)
     * 客户端-指定图片类型,获取图片列表(不分页)
     */
    async webConfigWebsitImageConfigListImageTypeGetRaw(requestParameters: WebConfigWebsitImageConfigListImageTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListWebsitImageConfigInfoRespVo>> {
        if (requestParameters['imageType'] == null) {
            throw new runtime.RequiredError(
                'imageType',
                'Required parameter "imageType" was null or undefined when calling webConfigWebsitImageConfigListImageTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/list/{imageType}`.replace(`{${"imageType"}}`, encodeURIComponent(String(requestParameters['imageType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListWebsitImageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端-指定图片类型,获取图片列表(不分页) 客户端-指定图片类型,获取图片列表(不分页)
     * 客户端-指定图片类型,获取图片列表(不分页)
     */
    async webConfigWebsitImageConfigListImageTypeGet(requestParameters: WebConfigWebsitImageConfigListImageTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListWebsitImageConfigInfoRespVo> {
        const response = await this.webConfigWebsitImageConfigListImageTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 轮播图信分页列表 轮播图信息分页列表
     * 轮播图信息分页列表
     */
    async webConfigWebsitImageConfigPageGetRaw(requestParameters: WebConfigWebsitImageConfigPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataWebsitImageConfigInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling webConfigWebsitImageConfigPageGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling webConfigWebsitImageConfigPageGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['imageType'] != null) {
            queryParameters['imageType'] = requestParameters['imageType'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataWebsitImageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 轮播图信分页列表 轮播图信息分页列表
     * 轮播图信息分页列表
     */
    async webConfigWebsitImageConfigPageGet(requestParameters: WebConfigWebsitImageConfigPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataWebsitImageConfigInfoRespVo> {
        const response = await this.webConfigWebsitImageConfigPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 轮播图数据创建 轮播图数据创建
     * 轮播图数据创建
     */
    async webConfigWebsitImageConfigPostRaw(requestParameters: WebConfigWebsitImageConfigPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWebsitImageConfigReqVoToJSON(requestParameters['createWebsitImageConfigReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 轮播图数据创建 轮播图数据创建
     * 轮播图数据创建
     */
    async webConfigWebsitImageConfigPost(requestParameters: WebConfigWebsitImageConfigPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.webConfigWebsitImageConfigPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·轮播图列表（不分页） 客户端·轮播图列表（不分页）
     * 客户端·轮播图列表（不分页）
     */
    async webConfigWebsitImageConfigQueryListGetRaw(requestParameters: WebConfigWebsitImageConfigQueryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListWebsitImageConfigInfoRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['imageType'] != null) {
            queryParameters['imageType'] = requestParameters['imageType'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/query-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListWebsitImageConfigInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端·轮播图列表（不分页） 客户端·轮播图列表（不分页）
     * 客户端·轮播图列表（不分页）
     */
    async webConfigWebsitImageConfigQueryListGet(requestParameters: WebConfigWebsitImageConfigQueryListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListWebsitImageConfigInfoRespVo> {
        const response = await this.webConfigWebsitImageConfigQueryListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定image_type,获取图片列表(等待排序)数据回显 指定image_type,获取图片列表(等待排序)数据回显
     * 指定image_type,获取图片列表(等待排序)数据回显
     */
    async webConfigWebsitImageConfigSortImageTypeGetRaw(requestParameters: WebConfigWebsitImageConfigSortImageTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetWebsitImageConfigSortListRespVo>> {
        if (requestParameters['imageType'] == null) {
            throw new runtime.RequiredError(
                'imageType',
                'Required parameter "imageType" was null or undefined when calling webConfigWebsitImageConfigSortImageTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/sort/{imageType}`.replace(`{${"imageType"}}`, encodeURIComponent(String(requestParameters['imageType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetWebsitImageConfigSortListRespVoFromJSON(jsonValue));
    }

    /**
     * 指定image_type,获取图片列表(等待排序)数据回显 指定image_type,获取图片列表(等待排序)数据回显
     * 指定image_type,获取图片列表(等待排序)数据回显
     */
    async webConfigWebsitImageConfigSortImageTypeGet(requestParameters: WebConfigWebsitImageConfigSortImageTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetWebsitImageConfigSortListRespVo> {
        const response = await this.webConfigWebsitImageConfigSortImageTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 轮播图数据排序接口 轮播图数据排序接口 轮播图数据排序接口,用于前端页面的拖拽排序
     * 轮播图数据排序接口
     */
    async webConfigWebsitImageConfigSortPutRaw(requestParameters: WebConfigWebsitImageConfigSortPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config/sort`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebsitImageConfigSortReqVoToJSON(requestParameters['websitImageConfigSortReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 轮播图数据排序接口 轮播图数据排序接口 轮播图数据排序接口,用于前端页面的拖拽排序
     * 轮播图数据排序接口
     */
    async webConfigWebsitImageConfigSortPut(requestParameters: WebConfigWebsitImageConfigSortPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.webConfigWebsitImageConfigSortPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 网站图片配置注册方式options列表 网站图片配置注册方式options列表
     * 网站图片配置注册方式options列表
     */
    async webConfigWebsitImageConfigTypeOptionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListWebsitImageTypeReqVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/web-config/websit-image-config-type/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListWebsitImageTypeReqVoFromJSON(jsonValue));
    }

    /**
     * 网站图片配置注册方式options列表 网站图片配置注册方式options列表
     * 网站图片配置注册方式options列表
     */
    async webConfigWebsitImageConfigTypeOptionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListWebsitImageTypeReqVo> {
        const response = await this.webConfigWebsitImageConfigTypeOptionsGetRaw(initOverrides);
        return await response.value();
    }

}
